export const GET_EXPENSE_RECONCILIATION_PAGE = `
  query getConciliacionEgresosPage($input: ConciliacionEgresosPageInput!) {
    getConciliacionEgresosPage(input: $input) {
      items {
        transactionId
        numeroOperacion
        banco
        fecha
        monto
        estado
        transaccionVinculadaId
        variante
        pagoId
        comision
        proveedorNombre
        tipoOrden
        fechaPago
        estadoPago
        vinculoEncontrado
      }
      nextToken
      hasMore
    }
  }
`;
